import BaseQuery from "../BaseQuery";
import settings from '@/common/settings/env-settings';

export default class StartAuthQuery extends BaseQuery {
  
    public frontendRedirect: string;
    public tenantName: string;

    constructor(frontendRedirect: string, tenantName: string) {
        super();
        this.frontendRedirect = frontendRedirect;
        this.tenantName = tenantName;
    }

    public ConstructQueryString(): void {
        throw new Error("Method not implemented.");
    }

    public GetEndpoint(): string {
        return `api/genesys/authorize?frontendRedirect=${encodeURIComponent(this.frontendRedirect)}&tenantName=${encodeURIComponent(this.tenantName)}`;
    }

    // Instead of fetch call, we return the fully resolved URL
    public GetAuthUrl(): string {
        return settings.getGatewayUrl() + this.GetEndpoint();
    }

    // Not used here — override to prevent fetch attempts
    public override async Execute() {
        throw new Error("StartAuthQuery does not support Execute(). Use GetAuthUrl().");
    }
}
